module.exports = __webpack_public_path__ + "img/properties.80708646.svg";